/**
 * Admin card to download open RMAs CSV for a selected Global-e portal (activated merchant).
 */
import { observer } from "mobx-react-lite";
import React from "react";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import { Button } from "../../../components/inputs/button/button";
import Card from "../../../components/layouts/card/card";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import ShopsSelector from "../../../components/shops-selector/shops-selector";
import { FormFieldLine } from "../../../components/form-field-line/form-field-line";
import downloadOpenRmasStore from "./stores/download-open-rmas-store";
import { isSet } from "../../../models/model-types-methods";
import "./migrate-global-e-merchants.scss";
import { IShop } from "../../../models/User";

const DownloadOpenRmasCard: React.FC = observer(() => {
    const store = downloadOpenRmasStore;

    return (
        <Card
            isExpanded={true}
            toolbar={{
                title: (
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        Download Open RMAs for an Activated Global-e Merchant
                    </FontBody1>
                ),
            }}
        >
            <ListLayout>
                <FormFieldLine label="Select a Global-e portal to download Open RMAs CSV file">
                    <ShopsSelector
                        value={store.portal ? [store.portal] : ([] as IShop[])}
                        onChange={(shops: IShop[]) => store.setPortal(shops[0])}
                        disabled={store.isProcessing}
                        includeSecondaryPortals
                    />
                </FormFieldLine>

                <Button
                    onClick={() => store.download()}
                    text="Download"
                    hasLoader={true}
                    isLoading={store.isProcessing}
                    disabled={store.isProcessing || !isSet(store.portal)}
                />

                {store.infoMessage ? (
                    <div className="results-message">
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>{store.infoMessage}</FontBody1>
                    </div>
                ) : null}
            </ListLayout>
        </Card>
    );
});

export default DownloadOpenRmasCard;
